import thaiCitizenIdValidator from '@/libs/thaiCitizenIdValidator'

export const lineBasicIdValidator = (id) => {
  const regexLineAt = new RegExp(/^@[a-z]{3}[0-9]{4}[a-z]{1}$/g)
  const regexLineOa = new RegExp(/^@[0-9]{3}[a-z]{5}$/g)

  return regexLineAt.test(id) || regexLineOa.test(id)
}

export const premiumIdvalidator = (premiumId) => {
  // case 1 overal
  let regex = new RegExp(/^@[0-9a-z._-]{4,18}$/)
  const resultCase1 = regex.test(premiumId)

  // case 2 number only
  regex = new RegExp(/^@[0-9]+$/)
  const resultCase2 = regex.test(premiumId)

  // case 3 '.', '_', '-' only
  regex = new RegExp(/^@[._-]+$/)
  const resultCase3 = regex.test(premiumId)

  // case 4 check has alphabel a-z
  regex = new RegExp(/[a-z]/)
  const resultCase4 = regex.test(premiumId)

  return resultCase1 && !resultCase2 && !resultCase3 && resultCase4
}

export const startWithAt = (value) => {
  const regex = new RegExp(/^@/)
  return regex.test(value)
}

export const citizenIdValidator = (value, isJuristicCustomer) => {
  if (isJuristicCustomer) {
    const regex = new RegExp(/^[0-9]{13}$/)
    return regex.test(value)
  }

  return thaiCitizenIdValidator(value)
}

export const decimals = (value, length) => {
  const regexString = `^[0-9]\\d{0,9}(\\.\\d{1,${length}})?%?$`
  const regex = new RegExp(regexString)

  return regex.test(value)
}

export const maximumSizeFile = (files, size = 10) => {
  const maximum = 1024 * 1024 * Number(size)
  return !files || !files.some((file) => file.size > maximum)
}
